import { AttachmentType } from './types/attachment';
import { DEFAULT_ATTACHMENT_CONFIG } from './constants';
import { frequencyConfigDefaulValues } from './constants/defaultVal';
import { ScheduleSendValues } from './types/scheduleSend';
import { View } from 'common/types/view';

export const scheduledSendDefaultValues = (view: View) => {
  return {
    name: view.name,
    subject: view.name,
    recipients: [],
    attachmentConfigs: [createDefaultPDFFullReport()],
    frequencyConfig: frequencyConfigDefaulValues,
  } as ScheduleSendValues;
};

export const createDefaultPDFFullReport = () => ({
  value: DEFAULT_ATTACHMENT_CONFIG.value,
  format: DEFAULT_ATTACHMENT_CONFIG.format,
  type: DEFAULT_ATTACHMENT_CONFIG.type as AttachmentType,
  name: DEFAULT_ATTACHMENT_CONFIG.name,
});

export const defaultPDFFullReport = createDefaultPDFFullReport();
